export default "__VITE_ASSET__C_d0F$WB__"